<script setup lang="ts">
import type { CheckEmail } from '../types'
import { useI18n } from '@/composables/i18n'

const { i18n } = useI18n()

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<{
    checkEmail: CheckEmail
}>()

function escapeHtml(value: string): string {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
}

function formatMessage(message: string): string {
    // escape first so the user-controlled email in the message can't inject markup,
    // then add only the limited formatting we allow (email highlight + line breaks)
    return escapeHtml(message)
        .replace(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g, '<strong>$1</strong>')
        .replace(/\n/g, '<br>')
}

</script>

<template>
    <header>
        <h2>{{ i18n.t('Passwort zurücksetzen') }}</h2>
        <p
            class="message"
            v-html="formatMessage(props.checkEmail.message)"
        ></p>
    </header>

    <div class="options">
        <a :href="props.checkEmail.loginUrl">
            {{ i18n.t('Zurück zum Login') }}
        </a>
    </div>
</template>

<style scoped>
@reference "@/assets/styles/config.css";

header {
    @apply mb-4;

    h2 {
        @apply text-2xl font-black mb-2;
    }

    .message {
        @apply text-gray-500 leading-normal font-medium whitespace-pre-line;
    }

    :deep(strong) {
        @apply font-bold text-gray-700;
    }
}

.options {
    @apply mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 justify-between;
    color:#415F70;

    a {
        @apply block flex-none font-bold hover:underline whitespace-nowrap;
    }
}
</style>
